// eslint-disable-next-line import/no-anonymous-default-export
export default function<T>() {
  return {
    not: (a: T[], b: T[]): T[] => a.filter((value) => b.indexOf(value) === -1),
    intersection: (a: T[], b: T[]): T[] => a.filter((value) => b.indexOf(value) !== -1),
    union: (a: T[], b: T[]): T[] => [...a, ...b.filter((value) => a.indexOf(value) === -1)]
  }
}